import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { updateStats } from './util.update-stats.js';

function useAttemptMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return taskId => mutater(entry => {
    const maxAttempts = data.settings.allowedAttempts;
    const taskEntry = entry.data.tasks[taskId] ??= makeInitialOpgavekompleksetTaskEntry(data, taskId);
    updateStats(entry, data, taskId);
    taskEntry.state.attempts = Math.min(maxAttempts, taskEntry.state.attempts + 1);
    taskEntry.state.validated = true;
    taskEntry.state.skipped = false;
    return entry;
  });
}

export { useAttemptMutation };
//# sourceMappingURL=use-attempt.js.map
